module.exports = __webpack_public_path__ + "static/bayashi_ok-7311a890df610464612d2e55582da3d3.jpg";